import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IonicComponentsModule } from 'src/app/modules/ionic-components.module';
import { IonModal } from '@ionic/angular/standalone'
import { CanvasDrawingComponent } from '../canvas-drawing/canvas-drawing.component';
import { UtilService } from 'src/app/services/util.service';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'fv-firma-local',
  templateUrl: './firma-local.component.html',
  styleUrls: ['./firma-local.component.scss'],
  standalone: true,
  imports: [
    IonicComponentsModule,
    CanvasDrawingComponent
  ]
})
export class FirmaLocalComponent  implements OnInit {

  //#region Propiedades

  @ViewChild("mdlFirma") public mdlFirma: IonModal
  @Input("width") public width: number = 800
  @Input("height") public height: number = 500
  @ViewChild("canvasDrawing") public canvasDrawing: CanvasDrawingComponent
  @Input("firmaImage") public backgroundImage: string
  @Input("disclaimer") public disclaimer: string
  @Output("firmado") public firmadoEvent = new EventEmitter<string>()

  //#endregion

  //#region Constructor

  constructor(
    private util: UtilService,
    private alertService: AlertService
  ) { }

  //#endregion

  //#region Init

  ngOnInit() {}

  //#endregion

  //#region Firma

  public async open(): Promise<void> {
    if (this.backgroundImage == null) {
      this.backgroundImage = this.util.createWhiteImage(this.width, this.height, 'transparent')
    }
    this.mdlFirma.isOpen = true

    await this.util.Sleep(1)
    this.canvasDrawing.backgroundImage = this.backgroundImage
  }

  public async guardarFirma(): Promise<void> {
    try {
      this.mdlFirma.isOpen = false
      let image = this.canvasDrawing.toDataUrl()
      this.firmadoEvent.emit(image)
    } catch (ex) {
      await this.alertService.showMessage(`Error al guardar la firma: ${ex?.message || 'No se ha podido obtener la imagen'}`, 'Firmar conformidad')
    }
  }

  //#endregion

}
